import React from 'react'
import UserCreateForm from '../../../../forms/User/Create'
import PageHeader from '../../PageHeader'
import PageContent from '../../PageContent'
import Button from '../../../../components/Button'
import isAdmin from '../../../../utils/is-admin'
import routes from '../../../../config/routes'
import { useAuth } from '@polvo-labs/react-auth'
import { useHistory } from 'react-router'

interface Props {

}

const UserCreateScreen: React.FC<Props> = () => {
  const { user } = useAuth()
  const history = useHistory()

  return (
    <div>
      <PageHeader
        title="Novo usuário"
        subtitle="Cadastrar novo usuário"
        side={isAdmin(user) ? (<>
          <Button
            label="Listar usuário"
            backgroundColor="darkBlue"
            fontColor="white"
            borderColor="lightGray"
            small
            onClick={() => {
              history.push(routes.admin.user.index.path)
            }}
          />
        </>) : undefined}
      />
      <PageContent>
        <UserCreateForm />
      </PageContent>
    </div>
  )
}

export default UserCreateScreen
